module.exports = __tmimport("~endpoint:{controller: \'customized/shop\', action: \'check_out\'}");